// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","extraMenu":"_1cRi2","desktopMenu":"_28woa","menu":"nblzI","openedMenu":"ohNyi","localsMenu":"_2UdMi","ctaMenu":"_1MbLL"};